import { Provider } from "react-redux";
import React, { useContext } from "react";
import { ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router } from "react-router-dom";

import AuthContext from "./context/Auth";
import { createTheming } from "./utils/Theme";
import RouteConfig from "./routes/RouteConfig";
import { store, persistor } from "./redux/store";
import SettingsContext from "./context/SettingsContext";
import { PersistGate } from "redux-persist/integration/react";

const App = () => {
  const themeSeeting = useContext(SettingsContext);
  const theme = createTheming({
    theme: themeSeeting.settings.theme,
  });

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className="App">
          <ThemeProvider theme={theme}>
            <AuthContext>
              <Router>
                <RouteConfig />
                <ToastContainer position="top-right" />
              </Router>
            </AuthContext>
          </ThemeProvider>
        </div>
      </PersistGate>
    </Provider>
  );
};

export default App;
